// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__MvR+d","footerItem":"Footer_footerItem__6Q6xV","footerIcons":"Footer_footerIcons__0Tpny"};